import axios from 'axios';
import { getApiBase } from './utils/apiConfig';

// Ensure axios sends cookies/credentials on same-origin or cross-origin requests
axios.defaults.withCredentials = true;

// Resolve the correct backend base URL on every request so that production
// hostname detection (movd.ca → movd-1.onrender.com) is always current.
axios.interceptors.request.use((config) => {
  // Only rewrite relative URLs (those that don't start with http)
  if (config.url && !config.url.startsWith('http')) {
    const base = getApiBase().replace(/\/$/, '');
    // Remove any leading /api from the path since getApiBase() already includes /api
    const path = config.url.replace(/^\/api/, '');
    const separator = path.startsWith('/') ? '' : '/';
    config.url = `${base}${separator}${path}`;
  }
  return config;
});

export default axios;
